// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconStarFilled = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12.595 3H10.8L8.253 8.164l-5.699.828L2 10.697l4.124 4.02-.974 5.675 1.451 1.055 5.097-2.68 5.097 2.68 1.45-1.055-.973-5.675 4.124-4.02-.554-1.705-5.699-.828z" />
  );
export default SvgIconStarFilled;
